import { render } from "./HeroiconsOutlineCake.vue?vue&type=template&id=f167775c"
const script = {}

import exportComponent from "/Users/ace/vscode/aau/scenario-maker/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineCake.vue"]])

export default __exports__